import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core'
import React from 'react'
import { X } from 'react-feather'
import { useTranslation } from 'react-i18next'
import type { BuildingEnergyModelFragment } from '../../../generated/graphql'
import { useHeaderStyles } from '../../system-container/SystemContainerHeader'
import { BuildingEnergyModelDrawerContent } from './BuildingEnergyModelDrawerContent'

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
  },
  paper: {
    background: theme.palette.background.default,
    height: '100%',
  },
  title: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
}))

type Props = {
  isOpen: boolean
  onClose: () => void
  energyModel: BuildingEnergyModelFragment
}

export function BuildingEnergyModelDrawer({
  isOpen,
  onClose,
  energyModel,
}: Props): React.ReactElement {
  const classes = useStyles()
  const headerClasses = useHeaderStyles()
  const { t } = useTranslation()
  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      anchor="bottom"
      classes={{ paper: classes.paper }}
    >
      <AppBar className={headerClasses.appBar}>
        <Toolbar className={headerClasses.toolbar}>
          <IconButton className={headerClasses.appBarButton} onClick={onClose}>
            <X />
          </IconButton>
          <Typography variant="body2">
            {t('buildingEnergyModels.drawer.close')}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box display="flex">
        <main className={classes.content}>
          <Toolbar className={headerClasses.toolbar} />
          <Box flexGrow={1}>
            <BuildingEnergyModelDrawerContent
              model={energyModel}
              onClose={onClose}
            />
          </Box>
        </main>
      </Box>
    </Drawer>
  )
}
